import { Controller } from "@hotwired/stimulus"

// Shared subscription extras catalog UX: dependent products, select-to-reveal,
// purchase enable/disable. Wire new dependencies with data-requires-product only.
export default class extends Controller {
  static targets = ["product", "select", "purchase", "hint"]
  static classes = ["hidden"]

  connect() {
    this.refresh()
  }

  selectionChanged() {
    this.refresh()
  }

  refresh() {
    const ownedByCode = {}
    const selectedByCode = {}

    this.productTargets.forEach((el) => {
      const code = el.dataset.productCode
      if (!code) return

      ownedByCode[code] = el.dataset.owned === "true"
      const select = el.querySelector('[data-subscription-catalog-target="select"]')
      selectedByCode[code] = Boolean(select?.checked)
    })

    this.productTargets.forEach((el) => {
      const requires = el.dataset.requiresProduct
      if (!requires) return

      const prereqSatisfied =
        el.dataset.prerequisiteSatisfied === "true" || ownedByCode[requires] === true
      const visible = prereqSatisfied || selectedByCode[requires] === true

      el.classList.toggle(this.hiddenClassName, !visible)
      this.#setPurchasesEnabled(el, prereqSatisfied)
      this.#setHintsVisible(el, !prereqSatisfied && visible)
    })
  }

  get hiddenClassName() {
    return this.hasHiddenClass ? this.hiddenClass : "d-none"
  }

  #setPurchasesEnabled(productEl, enabled) {
    productEl.querySelectorAll('[data-subscription-catalog-target="purchase"]').forEach((node) => {
      if (node.matches("input, button, select, textarea")) {
        node.disabled = !enabled
        return
      }

      node.querySelectorAll("input, button, select, textarea").forEach((control) => {
        if (control.type === "hidden") return
        control.disabled = !enabled
      })
    })
  }

  #setHintsVisible(productEl, visible) {
    productEl.querySelectorAll('[data-subscription-catalog-target="hint"]').forEach((hint) => {
      hint.classList.toggle(this.hiddenClassName, !visible)
    })
  }
}
